






















import { Checkbox } from 'ant-design-vue'
import { Component, Emit, Mixins } from 'vue-property-decorator'

import ConfigField from '../../../../components/ConfigField/ConfigField.vue'
import FieldTitle from '../../../Pi/components/FieldTitle.vue'
import Validation from '../../components/Validation.vue'
import { BaseInput, FieldTranslationsKeys } from '../../mixins'
import { FieldData } from '../../types'

@Component({
  components: {
    FieldTitle,
    Validation,
    ConfigField
  },
})
export default class CheckboxInput extends Mixins(BaseInput, FieldTranslationsKeys) {
  @Emit('change')
  change(value: Event): Event {
    return value
  }

  get checkboxInputSettings(): FieldData & Checkbox {
    return this.settings as FieldData & Checkbox
  }

  get indeterminate(): boolean {
    return this.checkboxInputSettings.indeterminate
  }
}
